// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QY50","name":"styles_name__26hnd","phone":"styles_phone__5TM_7"};